<template>
  <div class="mx-auto col-md-10 mx-auto">
      <div v-if="loading" class="text-center my-5">
          <b-spinner></b-spinner>
      </div>
    <b-row v-else>
        <b-col>
            <h4>Online</h4>
            <b-list-group class="mx-auto">
            <b-list-group-item class="d-flex align-items-center" v-for="(data, index) in onlineAgents" :key="index">
                <b-avatar :src="data.displayPicture" class="mr-3"></b-avatar>
                <div class="mr-auto">{{data.userName}}
                        <p class="m-0 p-0">last seen on {{data.updatedAt| moment('ll')}}</p>
                </div>
                <b-badge :variant="data.isOnline ? 'success': 'danger'">{{data.isOnline? 'Online': 'Offline'}}</b-badge>
            </b-list-group-item>
        </b-list-group>
        </b-col>
        <b-col>
            <h4>Offline</h4>
            <b-list-group class="mx-auto">
            <b-list-group-item class="d-flex align-items-center" v-for="(data, index) in offlineAgents" :key="index">
                <b-avatar :src="data.displayPicture" class="mr-3"></b-avatar>
                <div class="mr-auto">{{data.userName}}
                        <p class="m-0 p-0">last seen on {{data.updatedAt| moment('ll')}}</p>
                </div>
                <b-badge :variant="data.isOnline ? 'success': 'danger'">{{data.isOnline? 'Online': 'Offline'}}</b-badge>
            </b-list-group-item>
        </b-list-group>
        </b-col>
    </b-row>
  </div>
</template>

<script>
import {HTTP2} from '../../axios/http-common'
import * as _ from 'lodash'
export default {
    data(){
        return{
            allAgents: [],
            onlineAgents: [],
            offlineAgents: [],
            loading: false
        }
    },
    async created() {
        this.loading = true
        try {
            const {data} = await HTTP2.get('/get/agent')
            const sorted = _.orderBy(data, 'updatedAt', 'desc')
            this.onlineAgents = sorted.filter(x=>{
                return x.isOnline == 1
            })
            this.offlineAgents = sorted.filter(x=>{
                return x.isOnline == 0
            })
        }catch(err){
            console.log(err)
        } finally {
            this.loading = false
        }
    }

}
</script>

<style>

</style>